import { Injectable } from '@angular/core';
import { SyssfServicePkg } from './syssfPkg.service';

@Injectable({
  providedIn: 'root',
})
export class SyssfService extends SyssfServicePkg {
  constructor() {
    super();
  }
}
